/**
* @author: Angel Labrada Massó
* @version: v0.0.1
* @date: 17/10/2022
*/
import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import {useTranslation} from 'react-i18next';

const {Option} = Select;

const SelectClassification = ({value, onChange, setClassification, ...props}) => {
  const {t} = useTranslation('registers');

  const handleChange = useCallback((val) => {
    onChange(val);
    setClassification(val);
  }, [onChange, setClassification]);

  return (
    <Select
      placeholder={t('form.placeholderClassification')}
      value={value}
      onChange={handleChange}
      {...props}
      className="custom-select"
    >
      <Option value="measurement">{t('measurement')}</Option>
      <Option value="cleaning">{t('cleaning')}</Option>
      <Option value="maintenance">{t('maintenance')}</Option>
    </Select>
  );
};
 
SelectClassification.propTypes = {
  value: PropTypes.string, 
  onChange: PropTypes.func,
  setClassification: PropTypes.func,
};
 
SelectClassification.defaultProps = {};
 
export default memo(SelectClassification);
 
const ClassificationView = ({entity}) => {
  const {t} = useTranslation('registers');

  return (
    <div className="w-full">
      {entity?.classification
        ? (
          <div className="flex items-center justify-start flex-wrap gap-3">
            {t(entity?.classification)}
          </div>
        ) : 'N/A'}
    </div>
  );
};

ClassificationView.propTypes = {
  value: PropTypes.array,
  entity: PropTypes.object,
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {Array} value this is the value of the dataIndex of the table
 * @param {Object} form this is the value of the dataIndex of the table
 * @param {Object} entity this is the value of the dataIndex of the table
 * */
export const renderClassification = (value, form, entity) => {

  return (
    <ClassificationView value={value} entity={entity}/>
  );
};